module.exports = __webpack_public_path__ + "media/application/images/icons/icon-warning-705f579582d518d2d461080efef5abfb.svg";